import { getClientIp } from "~/lib/getClientIp";

/**
 * sc_flag を解決する。
 *
 * - existingScFlag が true の場合はIP判定をスキップしてそのまま true を返す
 * - それ以外は VITE_DEBUG_ALLOWED_IPS と現在のIPを照合して判定する
 * - IP取得失敗・環境変数未設定の場合は false を返す
 */
export const resolveScFlag = async (
  existingScFlag?: boolean,
): Promise<boolean> => {
  if (existingScFlag === true) {
    return true;
  }

  const allowedIps = import.meta.env.VITE_DEBUG_ALLOWED_IPS;
  if (!allowedIps) {
    return false;
  }

  const ip = await getClientIp();
  if (!ip) {
    return false;
  }

  const list = allowedIps.split(",").map((s) => s.trim());
  return list.includes(ip);
};
